import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";
const GetPropertyFeatures = async () => {
  /**
   * input: null
   * output: property features object
   * description: fetches complete property features
   */
  try {
    let clientCollection = doc(db, "clients", getLocalStorageItem("bid"));

    let dynamicPropertyCollection = collection(
      clientCollection,
      "dynamicFields"
    );
    let propertyFeaturesCollection = doc(dynamicPropertyCollection, "property");

    const featuresSnapshot = await getDoc(propertyFeaturesCollection);
    const propertyFeatures = featuresSnapshot.data();
    return propertyFeatures;
  } catch (error) {
    console.log(error);
  }
};

export default GetPropertyFeatures;
